import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings";
import {SectionDescription} from "components/misc/Typography";
import { ReactComponent as TwitterIcon} from "images/twitter-icon.svg";
import { ReactComponent as LinkedinIcon} from "images/linkedin-icon.svg";
import { ReactComponent as GithubIcon } from "images/github-icon.svg";

import DN from './../../images/DN.jpg';
import WA from './../../images/WA.jpg';
import WJU from './../../images/WJU.jpg';
import WJ from './../../images/WJ.jpg';
import JD from './../../images/JD.jpg';
import LJ from './../../images/LJ.jpg';
import JT from './../../images/JT.jpg';

const HeadingContainer = tw.div``
const Heading = tw(SectionHeading)``
const Subheading = tw(SubheadingBase)`text-center mb-3`
const Description = tw(SectionDescription)`mx-auto text-center`

const Cards = tw.div`flex flex-wrap flex-row justify-center sm:max-w-2xl lg:max-w-5xl mx-auto`
const Card = tw.div`mt-24 w-full sm:w-1/2 lg:w-1/3 flex flex-col items-center`
const CardImage = styled.div(({ imageSrc }) => [
  css`
    background-image: url("${imageSrc}");
    position: relative;
    overflow: hidden;

    /* The text overlay */
    &::after {
      content: attr(data-hovertext);
      ${tw`absolute inset-0 flex items-center justify-center text-center p-4 text-white`}
      background-color: rgba(0, 0, 0, 0.7);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &:hover {
      background-image: none;
    }

    &:hover::after {
      opacity: 1;
    }
  `,
  tw`w-64 h-64 bg-contain bg-center bg-no-repeat rounded`,
]);

const CardContent = styled.div`
  ${tw`flex flex-col items-center mt-6`}
  .position {
    ${tw`uppercase font-bold tracking-widest text-xs text-primary-500`}
  }
  .name {
    ${tw`mt-1 text-xl font-medium text-gray-900`}
  9
`

const CardLinks = styled.div`
  ${tw`mt-6 flex`}
  .link {
    ${tw`mr-8 last:mr-0 text-gray-400 hocus:text-primary-500 transition duration-300`}
    .icon {
      ${tw`fill-current w-6 h-6`}
    }
  }
`

export default ({
  heading = "Meet These Fine Folks.",
  subheading = "Our Team",
  description = "Founded in 2020 at the height of the COVID‑19 pandemic, Belle IT, INC is a health‑tech firm dedicated to giving community clinics the modern, secure software they need to deliver outstanding care. From day one our mission has been simple: build intuitive, HIPAA‑compliant tools that free clinicians to spend more time with patients and less time wrestling with technology.",
  cards = [
    {
      // eslint-disable-next-line no-template-curly-in-string
      imageSrc: DN,
      position: "Founder",
      name: "Dominique Northecide",
      imageTxt:"Results-oriented Founder w/ strong leadership, programming, artificial intelligence, data science & international experience in supporting software engineering apps. ",
      links: [
        
        {
          url: "https://www.linkedin.com/in/dominiquenorthecide/",
          icon: LinkedinIcon,
        },
        
      ],
    },
    {
      imageSrc: WA,
      position: "Chief Information Officer",
      name: "Wilker Altidor",
      imageTxt:"Innovative and results-driven Chief Information Officer (CIO) with a proven track record of leading technology teams and driving innovation.",
      links: [
        
        {
          url: "https://www.linkedin.com/in/wilkeraltidor/",
          icon: LinkedinIcon,
        },
        
      ],
    },
    {
      imageSrc: JT,
      position: "General Counsel",
      name: "Jayde Trabert",
      imageTxt:"Strategic and solutions-oriented General Counsel with a proven record of guiding organizations through complex legal matters while enabling business growth and innovation. ",
      links: [
       
        {
          url: "https://www.linkedin.com/in/jayde-trabert-8397611bb/",
          icon: LinkedinIcon,
        },
        
      ],
    },
    {
      imageSrc: LJ ,
      position: "Chief People Officer",
      name: "Leonard Jusme",
      imageTxt:"People-centered and adaptive Chief People Officer with a skills-based approach to fostering resilience, collaboration, and growth. ",
      links: [
        
        {
          url: "https://www.linkedin.com/in/leonard-jusme-lmhc-0423aa28/",
          icon: LinkedinIcon,
        },
        
      ],
    },
    {
      imageSrc: WJU,
      position: "Chief Digital Officer",
      name: "Woodney Juste",
      imageTxt:"Detail-oriented Chief Digital Officer with a unique blend of full-stack development expertise and behavioral health insights. Passionate about solving complex challenges through creative, accessible, and scalable digital solutions. ",
      links: [
       
        {
          url: "https://www.linkedin.com/in/woodneydev/",
          icon: LinkedinIcon,
        },
        
      ],
    },
    {
      imageSrc: JD,
      position: "Head of Sales",
      name: "Jimmy Daphnis",
      imageTxt:"Dynamic and entrepreneurial Head of Sales with a proven ability to apply analytical insight and sound judgment to drive revenue growth.",
      links: [
        
        {
          url: "https://www.linkedin.com/in/jdaphnis/",
          icon: LinkedinIcon,
        },
        
      ],
    },
  ]
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading> }
          {description && <Description>{description}</Description> }
        </HeadingContainer>
        <Cards>
          {cards.map((card, index) => (
            <Card key={index}>
              <CardImage 
              imageSrc={card.imageSrc} 
              data-hovertext={card.imageTxt} />
              <CardContent>
                <span className="position">{card.position}</span>
                <span className="name">{card.name}</span>
                <CardLinks>
                  {card.links.map((link, linkIndex) => (
                    <a key={linkIndex} className="link" href={link.url}>
                      <link.icon className="icon" />
                    </a>
                  ))}
                </CardLinks>
              </CardContent>
            </Card>
          ))}
        </Cards>
      </ContentWithPaddingXl>
    </Container>
  );
};
